import { SearchFilterV4 } from "@/types/SearchFilter";

import fetcher_v2 from "../fetcher_v2";
import { URLS } from "../urls";

export const ASYNC_EXPORT_FORMAT = {
  CSV: "csv",
  EXCEL: "excel",
} as const;

export type AsyncExportFormat =
  (typeof ASYNC_EXPORT_FORMAT)[keyof typeof ASYNC_EXPORT_FORMAT];

type AsyncExportBody = {
  format: AsyncExportFormat;
  org_uuid: string;
  search_uuid?: string;
  tag?: string;
  filters?: SearchFilterV4;
};

type AsyncExportResponse = {
  export_job_uuid: string;
};

export const requestAsyncExport = (body: AsyncExportBody) => {
  return fetcher_v2<AsyncExportResponse, AsyncExportBody>(URLS.ASYNC_EXPORT, {
    method: "POST",
    body,
  });
};
